var map = {
	"./ar.png": 35680,
	"./de.png": 26506,
	"./en.png": 39581,
	"./es.png": 30261,
	"./fr.png": 98940,
	"./he.png": 64027,
	"./hu.png": 15182,
	"./icons8-austria.png": 19985,
	"./icons8-canada.png": 44522,
	"./icons8-china.png": 70052,
	"./icons8-france.png": 24580,
	"./icons8-germany.png": 76561,
	"./icons8-hungary.png": 93375,
	"./icons8-india.png": 7556,
	"./icons8-israel.png": 42958,
	"./icons8-italy.png": 57518,
	"./icons8-japan.png": 81573,
	"./icons8-new_zealand.png": 6398,
	"./icons8-saudi_arabia.png": 96056,
	"./icons8-singapore.png": 96171,
	"./icons8-south_korea.png": 88516,
	"./icons8-usa.png": 39690,
	"./it.png": 42517,
	"./ja.png": 85833,
	"./ko.png": 89624,
	"./ru.png": 64352,
	"./zh.png": 56929
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64307;